export default __webpack_public_path__ + "static/media/vg_logo_small.3cb1c10f.svg";